import React from "react";
import useTemplate from "@/react/hooks/useTemplate";
import { createInstance } from "@/react/Providers/TemplateInstanceProvider";
import DrawTemplate from "@/react/components/Template/DrawTemplate";
import { placeholderUserImageUrlCreator, webshopUserImageUrlCreator, } from "@/react/lib/userImageUrlCreators";
// Renders one slot using the shared DrawTemplate pipeline — same renderer
// create_package2.php uses for the in-product template editor. Because
// the whole graphics layout is now HTML/CSS, DrawTemplate mounts directly
// inside the slot's div; no off-screen snapshot, no html2canvas, no
// foreignObject. Photos light up reactively as URLs load.
export function TemplateSlot({ slot, userResources, placeholders, }) {
    const [template] = useTemplate(slot.defaultTemplateUuid);
    // EpmsImage's default urlCreator reads from useAssetResolver(), which
    // this renderer doesn't sit inside, so it is passed explicitly. Real
    // photos are always a webshop request; a placeholder's uuid IS the asset
    // path, so its creator hands the uuid back untouched.
    const userImageUrlCreator = placeholders
        ? placeholderUserImageUrlCreator
        : webshopUserImageUrlCreator;
    if (!template) {
        return null;
    }
    const templateInstance = createInstance(template, userResources);
    const w = slot.width;
    const h = slot.height;
    // Sized to the slot's box. The parent slot wrapper handles positioning
    // and rotation; DrawTemplate just fills the slot's interior.
    return (React.createElement("div", { style: {
            position: "absolute",
            left: 0,
            top: 0,
            width: `${w}px`,
            height: `${h}px`,
        } },
        React.createElement(DrawTemplate, { templateInstance: templateInstance, containerSize: { width: w, height: h }, userImageUrlCreator: userImageUrlCreator, 
            // Package-graphics is a layout-design preview, not a quality
            // gate — the end user can't act on per-cell warnings here.
            hideQualityWarning: true })));
}
